export const StatCard = ({ label, value, sub, icon: Icon, testId, accent, variant = "light" }) => {
  const dark = variant === "dark";
  return (
    <div
      data-testid={testId}
      data-kpi
      className={`afm-fade-up group relative overflow-hidden rounded-2xl border p-5 transition-all ${
        dark
          ? "border-white/10 bg-[#120404] text-white shadow-[0_12px_30px_-12px_rgba(0,0,0,0.6)] hover:border-[#CA0808]/60"
          : "border-slate-200 bg-white hover:border-black hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)]"
      }`}
    >
      {dark && <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-[#CA0808]/30 blur-3xl" />}
      <div className="relative flex items-start justify-between">
        <div className={`text-[11px] font-semibold uppercase tracking-[0.18em] ${dark ? "text-[#9CA3AF]" : "text-slate-500"}`}>
          {label}
        </div>
        {Icon && (
          <div className={`rounded-lg p-2 transition-colors ${dark ? "bg-[#270A0A] text-[#FF8A90] group-hover:bg-[#CA0808] group-hover:text-white" : "bg-slate-100 text-slate-700 group-hover:bg-[#CA0808] group-hover:text-white"}`}>
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      <div className={`relative mt-3 font-display text-2xl font-bold tabular-nums lg:text-3xl ${accent || (dark ? "text-white" : "text-black")}`}>
        {value}
      </div>
      {sub && <div className={`relative mt-1 text-xs ${dark ? "text-[#9CA3AF]" : "text-slate-500"}`}>{sub}</div>}
    </div>
  );
};
